
import { Vue, Component, Prop } from 'vue-property-decorator';
import ActivityFormModal from '@/components/projects/activities/ActivityFormModalNew.vue';
import { Project } from '@/interface';
import { Project_Activity, User } from '@/generated/graphql';
import AddIcon from "@/components/icons/AddIcon.vue";
import AddIconHover from "@/components/icons/AddIconHover.vue";
import UiButton from '@/components/button/ui-button.vue';
import RouteNames from '@/entities/RouteNames';

@Component({
	components: {
		UiButton,
		ActivityFormModal,
		AddIcon,
		AddIconHover
	},
})
export default class AddTaskAction extends Vue {
	@Prop({ type: String, required: true }) readonly currentUserRole!: string;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: String, required: true }) readonly companyId!: string;
	@Prop({ type: Object, required: false }) readonly project!: Project;
	@Prop({ type: Object, default: undefined , required: false}) readonly projectId?: string;
	@Prop({ type: Object, default: undefined })
	readonly projectActivity?: Project_Activity;
	@Prop({ type: String, default: undefined }) readonly contractorId?: string;
	@Prop({ type: Boolean, default: false })
	readonly redirectToDetails!: boolean;

	modalShown: boolean = false;
	isHovered: boolean = false;

	get buttonText(): string {
		if (this.projectActivity) {
			return 'Edit Task';
		}

		return 'Add Task';
	}
	showModal(): void {
		this.modalShown = true;
	}

	hideModal(): void {
		this.modalShown = false;
	}

	onActivityAdded(): void {
		this.modalShown = false;

		this.$router.push({
			name: RouteNames.PROJECT_ACTIVITY,
			params: {
				id: this.project.id!,
			},
		});
	}
}
